import img1 from "../../images/img-1.jpg";
import img2 from "../../images/img-2.png";
import img3 from "../../images/img-3.png";
import img4 from "../../images/img-4.jpg";
import img5 from "../../images/img-5.png";
import img6 from "../../images/img-6.jpeg";
import img7 from "../../images/img-7.png";
import img8 from "../../images/img-8.png";
import img9 from "../../images/img-9.png";
import img10 from "../../images/img-10.jpg";
import img11 from "../../images/img-11.jpg";
import img12 from "../../images/img-12.jpg";
import img13 from "../../images/img-13.jpg";
import img14 from "../../images/img-14.jpg";
import img15 from "../../images/img-15.png";
import img16 from "../../images/img-16.png";
import img17 from "../../images/img-17.jpg";
import img18 from "../../images/img-18.jpg";

export const featuredPortfolio = [
  {
    image: img1,
    link: "https://netflix-clone-a0b74.firebaseapp.com/",
    github: "https://github.com/yogesh-kumar-27/React-netflix",
  },
  {
    image: img2,
    link: "https://github.com/yogesh-kumar-27",
    github: "https://github.com/yogesh-kumar-27/Facebook-Clone",
  },
  {
    image: img3,
    link: "https://amazon-clone-opal.vercel.app/",
    github: "https://github.com/yogesh-kumar-27/amazon-clone",
  },
  {
    image: img4,
    link: "https://hulu-clone-eight-beryl.vercel.app/",
    github: "https://github.com/yogesh-kumar-27/Hulu-Clone",
  },
  {
    image: img5,
    link: "https://airbnb-clone-ruby.vercel.app/",
    github: "https://github.com/yogesh-kumar-27/Airbnb-clone",
  },
  {
    image: img6,
    link: "https://disney-plus-dj0dfshwi-yogesh-kumar-27.vercel.app/",
    github: "https://github.com/yogesh-kumar-27/disney-plus",
  },
  {
    image: img7,
    link: "https://yogesh-kumar-27.github.io/Adventure-Tour-Website/",
    github: "https://github.com/yogesh-kumar-27/Adventure-Tour-Website",
  },
  {
    image: img8,
    link: "https://yogesh-kumar-27.github.io/Tour-Travel-/",
    github: "https://github.com/yogesh-kumar-27/Tour-Travel-",
  },
  {
    image: img18,
    link: "https://yogesh-kumar-27.github.io/Easybank-landing-page/",
    github: "https://github.com/yogesh-kumar-27/Easybank-landing-page",
  },
];
export const ReactjsPortfolio = [
  {
    image: img1,
    link: "https://netflix-clone-a0b74.firebaseapp.com/",
    github: "https://github.com/yogesh-kumar-27/React-netflix",
  },
  {
    image: img2,
    link: "https://github.com/yogesh-kumar-27",
    github: "https://github.com/yogesh-kumar-27/Facebook-Clone",
  },

  {
    image: img7,
    link: "https://yogesh-kumar-27.github.io/Adventure-Tour-Website/",
    github: "https://github.com/yogesh-kumar-27/Adventure-Tour-Website",
  },
  {
    image: img8,
    link: "https://yogesh-kumar-27.github.io/Tour-Travel-/",
    github: "https://github.com/yogesh-kumar-27/Tour-Travel-",
  },
  {
    image: img9,
    link: "https://yogesh-kumar-27.github.io/fitness-website/",
    github: "https://github.com/yogesh-kumar-27/fitness-website",
  },
  {
    image:img16,
    link:"https://weather-app-ruddy-omega.vercel.app/",
    github:"https://github.com/yogesh-kumar-27/Weather-App"
  }
];
export const NextPortfolio = [
  {
    image: img3,
    link: "https://amazon-clone-opal.vercel.app/",
    github: "https://github.com/yogesh-kumar-27/amazon-clone",
  },
  {
    image: img5,
    link: "https://airbnb-clone-ruby.vercel.app/",
    github: "https://github.com/yogesh-kumar-27/Airbnb-clone",
  },
  {
    image: img4,
    link: "https://hulu-clone-eight-beryl.vercel.app/",
    github: "https://github.com/yogesh-kumar-27/Hulu-Clone",
  },
  {
    image: img6,
    link: "https://disney-plus-dj0dfshwi-yogesh-kumar-27.vercel.app/",
    github: "https://github.com/yogesh-kumar-27/disney-plus",
  },
  {
    image: img15,
    link: "https://medium2-0-flax.vercel.app/",
    github: "https://github.com/yogesh-kumar-27/medium2.0",
  },
  
];
export const designPortfolio = [
  {
    image: img10,
    link: "https://clipboard-landing-page007.netlify.app/",
    github: "https://github.com/yogesh-kumar-27/Clipboard-landing-page",
  },
  {
    image: img11,
    link: "https://yogesh-kumar-27.github.io/Loopstudios-landing-page/",
    github: "https://github.com/yogesh-kumar-27/Loopstudios-landing-page",
  },
  {
    image: img12,
    link: "https://yogesh-kumar-27.github.io/Sunnyside-agency-landing-page/",
    github: "https://github.com/yogesh-kumar-27/Sunnyside-agency-landing-page",
  },
  {
    image: img13,
    link: "https://yogesh-kumar-27.github.io/Huddle-landing-page-with-alternating-feature-blocks/",
    github: "https://github.com/yogesh-kumar-27/Huddle-landing-page-with-alternating-feature-blocks",
  },
  {
    image: img14,
    link: "https://yogesh-kumar-27.github.io/Fylo-landing-page/",
    github: "https://github.com/yogesh-kumar-27/Fylo-landing-page",
  },
  {
    image: img17,
    link: "https://yogesh-kumar-27.github.io/Frontend-Mentor-Bookmark-landing-page/",
    github: "https://github.com/yogesh-kumar-27/Frontend-Mentor-Bookmark-landing-page",
  },
  {
    image: img18,
    link: "https://yogesh-kumar-27.github.io/Easybank-landing-page/",
    github: "https://github.com/yogesh-kumar-27/Easybank-landing-page",
  },
];
// export default {featuredPortfolio,ReactjsPortfolio,NextPortfolio};
